registerGlobal( 'EmscriptenFullscreen' );

EmscriptenFullscreen.waitForFullscreenCallback = false;
EmscriptenFullscreen.fullscreenTimer = null;

EmscriptenFullscreen.isFullscreenOn = function() {
    return !!(document.fullscreenElement
        || document.mozFullScreenElement
        || document.webkitFullscreenElement
        || document.msFullscreenElement);
}

EmscriptenFullscreen.getCanvasScale = function() {
    if (!EmscriptenFullscreen.isFullscreenOn())
        return 1;

    var screenWidth = screen.width;
    var screenHeight = screen.height;
    // Non-Blink browsers take into account browser zoom
    // when reporting screen size, so we have to compensate for it.
    if (platform.layout !== "Blink") {
        screenWidth *= window.devicePixelRatio;
        screenHeight *= window.devicePixelRatio;
    }

    var scaleWindow = Math.min(window.innerWidth / appWidth, window.innerHeight / appHeight);
    var scaleScreen = Math.min(screenWidth / appWidth, screenHeight / appHeight);

    // ensure target canvas size is at least original canvas size (scale = 1)
    // and at most actual screen size (so at e.g. browser zoom 25% it doesn't get 4 times bigger)
    return Math.max(1, Math.min(scaleWindow, scaleScreen));
}


EmscriptenFullscreen.getCanvasStyleScale = function() {
    if (!EmscriptenFullscreen.isFullscreenOn())
        return 1;

    return Math.min(window.innerHeight / appHeight, window.innerWidth / appWidth);
}

EmscriptenFullscreen.toggleFullScreen = function() {
    EmscriptenFullscreen.waitForFullscreenCallback = true;
    EmscriptenFullscreen.fullscreenTimer = setTimeout(function() {
        // Just in case - try to ignore lack of the fullscreenchange event
        // after 4 seconds of waiting, since Safari sometimes doesn't throw it at all
        EmscriptenFullscreen.waitForFullscreenCallback = false;
    }, 4000);
    var documentElement = document.getElementById("fullscreen_container");
    var isFullscreen = EmscriptenFullscreen.isFullscreenOn();
    if (!isFullscreen) {
        if (documentElement.requestFullscreen) {
            documentElement.requestFullscreen();
        }
        else if (documentElement.msRequestFullscreen) {
            documentElement.msRequestFullscreen();
        }
        else if (documentElement.mozRequestFullScreen) {
            documentElement.mozRequestFullScreen();
        }
        else if (documentElement.webkitRequestFullscreen) {
            documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
    } else {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        }
        else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
        else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        }
        else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }
}

EmscriptenFullscreen.handleFullscreenChange = function() {
    EmscriptenFullscreen.waitForFullscreenCallback = false;
    if (EmscriptenFullscreen.fullscreenTimer) {
        clearTimeout(EmscriptenFullscreen.fullscreenTimer);
        EmscriptenFullscreen.fullscreenTimer = null;
    }

    EmscriptenFullscreen.onFullscreenUpdate();

    // Firefox doesn't repaint part of the page properly after leaving fullscreen mode
    // so this smart hack is used to force repaint of the page
    // Also sometimes Edge just stops repainting canvas after Fullscreen mode has been entered
    // So we force repaint of the canvas once, and then Edge do it automatically
    // see https://stackoverflow.com/questions/8840580/force-dom-redraw-refresh-on-chrome-mac
    $('body').hide().show(0);
}

EmscriptenFullscreen.tryToggleFullscreen = function() {
    if (!EmscriptenFullscreen.waitForFullscreenCallback) {
        EmscriptenFullscreen.toggleFullScreen();
    }
}

EmscriptenFullscreen.onFullscreenUpdate = function() {
    if (!EmscriptenFullscreen.isFullscreenOn()) {
        // reset all sizes and positions
        var obj = document.getElementById("canvas");
        obj.width = appWidth;
        obj.height = appHeight;
        obj.style.width = appWidth + 'px';
        obj.style.height = appHeight + 'px';

        obj = document.getElementById("canvas_container");
        obj.style.width = appWidth + 'px';
        obj.style.height = appHeight + 'px';
        obj.style.left = '0px';
        obj.style.top = '0px';

        obj = document.getElementById("fullscreen_container");
        obj.style.width = appWidth + 'px';
        obj.style.height = appHeight + 'px';
        return;
    }

    var scaleCanvas = EmscriptenFullscreen.getCanvasScale();
    var canvasWidth = appWidth * scaleCanvas;
    var canvasHeight = appHeight * scaleCanvas;
    var containerWidth = window.innerWidth;
    var containerHeight = window.innerHeight;
    var scaleCss = EmscriptenFullscreen.getCanvasStyleScale();
    var canvasCSSWidth = appWidth * scaleCss;
    var canvasCSSHeight = appHeight * scaleCss;
    var offsetX = (containerWidth - canvasCSSWidth) / 2;
    var offsetY = (containerHeight - canvasCSSHeight) / 2;

    // canvas.width/height is a size of the actual image we are drawing at,
    // and canvas.style.width/height is a size of a canvas on the page
    // (if they are the same, no scaling is applied,
    // but if they differ - actual image is streatched)
    var obj = document.getElementById("canvas");
    obj.width = canvasWidth;
    obj.height = canvasHeight;
    obj.style.width = canvasCSSWidth + 'px';
    obj.style.height = canvasCSSHeight + 'px';

    // canvas_container contains canvas and input fields
    // which has to be moved and resized in fullscreen as a whole
    obj = document.getElementById("canvas_container");
    obj.style.width = canvasCSSWidth + 'px';
    obj.style.height = canvasCSSHeight + 'px';
    obj.style.left = offsetX + 'px';
    obj.style.top = offsetY + 'px';

    // fullscreen_container is the element on which we call requestFullscreen()
    // so it should take whole window in the fullscreen mode
    // it contains canvas_container and provides black background
    obj = document.getElementById("fullscreen_container");
    obj.style.width = containerWidth + 'px';
    obj.style.height = containerHeight + 'px';

    // In Fullscreen mode only canvasCSSWidth and canvasCSSHeight
    // affect css scaling of the canvas
    if (Module && Module.EmscriptenSetCanvasScale) {
        Module.EmscriptenSetCanvasScale(scaleCss / scaleCanvas);
    }
}

//On Vivaldi F11 won't quit fullscreen.
document.addEventListener("keydown", function(e) {
    if (e.keyCode == 122) {
        if (EmscriptenFullscreen.isFullscreenOn()) {
            EmscriptenFullscreen.tryToggleFullscreen();
        }
    }
});

document.addEventListener("webkitfullscreenchange", EmscriptenFullscreen.handleFullscreenChange);
document.addEventListener("mozfullscreenchange", EmscriptenFullscreen.handleFullscreenChange);
document.addEventListener("fullscreenchange", EmscriptenFullscreen.handleFullscreenChange);
document.addEventListener("MSFullscreenChange", EmscriptenFullscreen.handleFullscreenChange);

window.addEventListener("resize", EmscriptenFullscreen.onFullscreenUpdate);



//////////////////
// WEBPACK FOOTER
// /src/src/platform/emscripten/Application.fullscreen.js
// module id = 23
// module chunks = 0